import LoadingButton from '@mui/lab/LoadingButton';
import { styled } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import Popper from '@mui/material/Popper';
import Stack from '@mui/material/Stack';

import EllipsisText from '@webclient/components/ellipsis-typography';

import { Input, Text } from '@knowz/knowz-ui';

const FULLY_ROUNDED = 999999;

export const StyledInput = styled(Input)(() => ({
  width: '100%',
  borderRadius: FULLY_ROUNDED,
  paddingRight: '0!important',
}));

export const StyledAutocomplete = styled(Autocomplete)(({ theme }) => ({
  backgroundColor: theme.palette.background.primaryAlt,
  padding: theme.spacing(2),
  border: '1px solid',
  borderColor: theme.palette.border.secondary,
  borderBottomColor: 'transparent',
  borderTopLeftRadius: theme.shape.borderRadius * 5,
  borderTopRightRadius: theme.shape.borderRadius * 5,
}));

export const StyledStackOptions = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(0),
  gap: theme.spacing(2),
  flexDirection: 'row',
}));

export const StyledStackOptionsItem = styled(Stack)(() => ({
  flexDirection: 'column',
  flex: 1,
}));

export const StyledDivider = styled(Divider)(({ theme }) => ({
  marginBlock: theme.spacing(2.5),
}));

export const StyledText = styled(Text)(({ theme }) => ({
  marginBlock: theme.spacing(2),
}));

export const StyledPopper = styled(Popper)(() => ({
  width: '100%',
  zIndex: 1,
}));

export const StyledImageBot = styled('img')(({ theme }) => ({
  width: theme.spacing(10),
  height: theme.spacing(10),
  borderRadius: FULLY_ROUNDED,
  objectFit: 'cover',
}));

export const StyledOnlineDot = styled('div')(({ theme }) => ({
  width: theme.spacing(2.5),
  height: theme.spacing(2.5),
  backgroundColor: theme.palette.success.main,
  position: 'absolute',
  bottom: 0,
  right: 0,
  borderRadius: FULLY_ROUNDED,
  border: '1px solid',
  borderColor: theme.palette.background.primary,
}));

export const StyledBox = styled('div')(({ theme }) => ({
  position: 'relative',
  width: theme.spacing(10),
  height: theme.spacing(10),
}));

export const StyledCategoryStack = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.utility.gray50,
  border: '1px solid',
  borderColor: theme.palette.utility.gray200,
  width: theme.spacing(5.5),
  height: theme.spacing(5.5),
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: theme.shape.borderRadius * 1.5,
  svg: {
    fontSize: '0.7em',
  },
}));

export const StyledSelectorButton = styled(LoadingButton)(({ theme }) => ({
  color:
    theme.palette[
      'Component colors/Components/Buttons/Tertiary/button-tertiary-fg'
    ],
  svg: {
    color: theme.palette.utility.gray600,
  },
  '&:hover': {
    background: 'transparent!important',
  },
}));

export const StyledListItem = styled(ListItem)<{ selected: boolean }>(
  ({ theme, selected }) => ({
    cursor: 'pointer',
    padding: theme.spacing(3),
    borderRadius: theme.shape.borderRadius * 3,
    backgroundColor: selected ? theme.palette.action.hover : 'transparent',
  }),
);

export const StyledEllipsis = styled(EllipsisText)(({ theme }) => ({
  textAlign: 'left',
  width: theme.spacing(15),
  textOverflow: 'ellipsis',
}));
